const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "350px";
    tooltipElement.style.width = "100%";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(10%, 0%)";
    tooltipElement.style.transition = "all .1s ease";
    tooltipElement.style.zIndex = 1;

    const table = document.createElement("table");
    table.style.margin = "0px";
    table.style.width = "100%";
    table.style.tableLayout = "fixed";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const transmissionTooltipHandler = (context) => {
  const { chart, tooltip } = context;
  const dataPoint = tooltip.dataPoints?.[0];
  const dataPoints = tooltip.dataPoints;

  const {
    label,
    dataIndex,
    dataset: { data },
  } = dataPoint || {};
  const tooltipElement = getOrCreateTooltip(chart);

  // Hide tooltip
  if (!data?.[dataIndex] || tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Clear previous content
  tooltipElement.innerHTML = "";

  const contentWrapper = document.createElement("div");
  contentWrapper.style.padding = "2px 4px";
  contentWrapper.style.maxWidth = "350px";

  // Add label/title
  if (label) {
    const title = document.createElement("div");
    title.textContent = label;
    title.style.fontSize = "14px";
    title.style.fontWeight = "600";
    title.style.marginBottom = "8px";
    contentWrapper.appendChild(title);
  }

  // Collect report data
  let nonBillableRows = [];
  let billableRows = [];

  dataPoints?.forEach(
    ({
      dataIndex,
      dataset: { backgroundColor, nonBillableReports, billableReports } = {},
    }) => {
      const nonBillable = nonBillableReports?.[dataIndex] || [];
      const billable = billableReports?.[dataIndex] || [];

      nonBillable.forEach((item) =>
        nonBillableRows.push({ ...item, backgroundColor })
      );
      billable.forEach((item) =>
        billableRows.push({ ...item, backgroundColor })
      );
    }
  );

  const bothColumns = nonBillableRows.length && billableRows.length;

  if (bothColumns) {
    // Use table layout if both columns exist
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.tableLayout = "fixed";

    const tableBody = document.createElement("tbody");
    const maxLength = Math.max(nonBillableRows.length, billableRows.length);

    for (let i = 0; i < maxLength; i++) {
      const row = document.createElement("tr");

      [nonBillableRows[i], billableRows[i]].forEach((rowItem) => {
        const cell = document.createElement("td");
        cell.style.width = "50%";
        cell.style.padding = "2px 4px";

        if (rowItem) {
          const wrapper = document.createElement("div");
          wrapper.style.display = "flex";
          wrapper.style.justifyContent = "space-between";
          wrapper.style.alignItems = "center";

          const label = document.createElement("span");
          if (
            rowItem.title === "Non Billable" ||
            rowItem.title === "Billable"
          ) {
            const dot = document.createElement("span");
            dot.style.background = rowItem.backgroundColor;
            dot.style.borderRadius = "50%";
            dot.style.marginRight = "5px";
            dot.style.width = "10px";
            dot.style.height = "10px";
            dot.style.display = "inline-block";
            label.appendChild(dot);
          }

          const titleText = document.createElement("span");
          titleText.textContent = rowItem.title;
          titleText.style.paddingLeft =
            rowItem.title === "Non Billable" || rowItem.title === "Billable"
              ? "0px"
              : "15px";
          label.appendChild(titleText);

          const count = document.createElement("span");
          count.textContent = rowItem.count;

          wrapper.appendChild(label);
          wrapper.appendChild(count);
          cell.appendChild(wrapper);
        }

        row.appendChild(cell);
      });

      tableBody.appendChild(row);
    }

    table.appendChild(tableBody);
    contentWrapper.appendChild(table);
  } else {
    // Fallback to single-column layout using divs
    const items = nonBillableRows.length ? nonBillableRows : billableRows;

    items.forEach(({ title, count, backgroundColor }) => {
      const row = document.createElement("div");
      row.style.display = "flex";
      row.style.justifyContent = "space-between";
      row.style.alignItems = "center";
      row.style.marginBottom = "6px";

      const label = document.createElement("span");

      if (title === "Non Billable" || title === "Billable") {
        const dot = document.createElement("span");
        dot.style.background = backgroundColor;
        dot.style.borderRadius = "50%";
        dot.style.marginRight = "5px";
        dot.style.width = "10px";
        dot.style.height = "10px";
        dot.style.display = "inline-block";
        label.appendChild(dot);
      }

      const titleText = document.createElement("span");
      titleText.textContent = title;
      titleText.style.paddingLeft =
        title === "Non Billable" || title === "Billable" ? "0px" : "15px";
      label.appendChild(titleText);

      const countSpan = document.createElement("span");
      countSpan.textContent = count;

      row.appendChild(label);
      row.appendChild(countSpan);

      contentWrapper.appendChild(row);
    });
  }

  tooltipElement.appendChild(contentWrapper);

  // Position
  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + "px";
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
};
